export default __webpack_public_path__ + "static/media/guotaijunan.27f54f72.png";